import { render, staticRenderFns } from "./BTableVPRPublications.vue?vue&type=template&id=6595da7e&"
import script from "./BTableVPRPublications.vue?vue&type=script&lang=js&"
export * from "./BTableVPRPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports